import { createFetchAndCacheAtomWithKey } from '@mostrans/web-components/helpers/atomHelpers';


export const ActiveOpportunityAtom = createFetchAndCacheAtomWithKey([]);
export const DetailOpportunityAtom = createFetchAndCacheAtomWithKey([]);
// export const MasterTestimonialAtom = createFetchAndCacheAtom([])